import React from 'react'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import TrashIcon from '../../elements/icons/TrashIcon'

const DesignationCard = ({designation, openDesignation, deleteDesignation}) => {
  return (
    <div className='p-3 relative min-h-[330px]'>
        <p className='font-medium'>{designation.name}</p>

        {designation.department && <p className='text-sm text-gray-500 font-medium mt-3'>
            Department: <span className='text-gray-700'>{designation.department.name} </span>
        </p>}

        {designation.responsibilities && <p className='text-lg text-gray-500 font-medium'>
            <span className='text-xs text-gray-500 mt-3 mr0.5'>{designation.responsibilities.length} responsibilities </span>
            {designation.canClassParent && <span className="px-2 py-1 rounded-lg bg-blue-100 font-space-grotesk text-blue-900 text-[10px] font-medium mr-0.5">Can Class Parent</span>}
            {designation.canHouseParent && <span className="px-2 py-1 rounded-lg bg-purple-100 font-space-grotesk text-vcm-purple text-[10px] font-medium">Can House Parent</span>}
        </p>}

        <p className='text-sm text-gray-500 mt-3'>{designation.description}</p>


        <div className="w-full flex items-center justify-between mt-3 p-3 border-t absolute left-0 bottom-0">
            <button onClick={()=>{openDesignation()}} className='text-sm flex flex-row items-center gap-x-3 text-vcm-purple hover:text-gray-400 transition duration-200'>View/Edit Designation <ArrowIcon className={`w-5 h-5`} /></button> 

            <button onClick={()=>{deleteDesignation()}} className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                <TrashIcon className={`w-5 h-5`} />
            </button>
        </div>
    </div>
  )
}

export default DesignationCard